import { render } from "./SelectionScreen.vue?vue&type=template&id=5cb2b1c6"
import script from "./SelectionScreen.vue?vue&type=script&lang=js"
export * from "./SelectionScreen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Jett\\Desktop\\bg-insieme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__